export default {
  props: {
    token: String,
    type: String,
    configId: String
  }
};
